import { render, staticRenderFns } from "./modalEditNews.vue?vue&type=template&id=29722fea&"
import script from "./modalEditNews.vue?vue&type=script&lang=js&"
export * from "./modalEditNews.vue?vue&type=script&lang=js&"
import style0 from "./modalEditNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports